import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const DispatchXRay = {
  apply: async (payload) => axios.post(API_URL + "/dispatch_x_ray/apply", payload).then(({ data }) => data.data).catch((err) => { throw err }),
  getSpecificDispatchNatures: async () => axios.get(API_URL + "/nature/get/specificDispatchNatures").then(({ data }) => data).catch((err) => { throw err }),
  getSpecificDispatchNaturesGroups: async () => axios.get(API_URL + "/nature/get/specificDispatchNaturesGroups").then(({ data }) => data).catch((err) => { throw err }),
};

export default DispatchXRay;